<div class="anim-loading" *ngIf="violations.length > 0; else noData">
  <div class="violations mb">
    <div class="violation pl-3">
      <div class="row">
        <div class="col" i18n>
          <p class="mb-0"><strong>Ponto/Faixa</strong></p>
        </div>
        <div class="col" i18n>
          <p class="mb-0"><strong>Data/Hora</strong></p>
        </div>
        <div class="col" i18n>
          <p class="mb-0"><strong>Placa</strong></p>
        </div>
      </div>
    </div>
  </div>
  <div class="violations" *ngFor="let violation of violations">
    <div
      class="violation mb-2 pt-2 pl-2"
      (click)="selectViolation(violation)"
      [ngClass]="{ 'active': lastData.passId === violation.passId }">
      <div class="row">
        <div class="col" i18n>
          <div class="content d-flex">
            <div class="color"
              [style]="{ 'background-color': getRegulationColor(violation?.regulationId) + '!important' }"></div>
            <p class="mb-0">
              {{ getSpotByPassId(violation?.passId) }} <br />
              Fx. {{ violation?.laneCode }}
            </p>
          </div>
        </div>
        <div class="col" i18n>
          <p>{{ violation?.date | moment: 'DD/MM/YYYY HH:mm:ss'}}</p>
        </div>
        <div class="col" i18n>
          <p>{{
            violation?.vehicle?.plate ||
            violation?.vehicle?.plateOCR ||
            '-'
            }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #noData>
  <p class="text-center anim-loading">
    <em>Aguardando recebimento de dados...</em>
  </p>
</ng-template>
<app-loading *ngIf="loadingList"></app-loading>
